import { render, staticRenderFns } from "./SlidesEdit.vue?vue&type=template&id=e57c5ea2&"
import script from "./SlidesEdit.vue?vue&type=script&lang=js&"
export * from "./SlidesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports